
$(document).ready(function() {
    // Event listener para cambios en los radio buttons
    $('.input-btn input[type="radio"]').on('change', function() {
        // Quitar la clase "checked" de todos los inputs
        $('.input-btn input[type="radio"]').removeClass('checked');

        var selectedRadio = $('.input-btn input[type="radio"]:checked');
        
        if (selectedRadio.length > 0) {
            // Agregar la clase "checked" al input seleccionado
            selectedRadio.addClass('checked');
            // Llamar a la función para calcular el precio al cambiar la selección
            calculateRetailPrice();
        }
    });

    // Event listener para el botón .btn-next
    $('.btn-next').on('click', function() {
        // Llamar a la función para calcular el precio cuando se hace clic en el botón
        calculateRetailPrice();
    });

    function calculateRetailPrice() {
        // Obtener todos los inputs seleccionados
        var selectedRadios = $('.input-btn input[type="radio"]:checked');
        var totalPrice = 0;

        // Iterar sobre los inputs seleccionados y sumar sus valores
        selectedRadios.each(function() {
            var price = parseFloat($(this).data('price'));

            // Verificar si el precio es un número válido
            if (!isNaN(price)) {
                totalPrice += price;
            }
        });

        // Mostrar el resultado en la clase .new-retail-price
        $('.new-retail-price #result-price').text('£' + totalPrice.toFixed(2));

        // Obtener el valor de #old-price-without después de establecer #result-price
        var oldPriceWithoutText = $('#old-price-without').text().trim();
        
        var oldPriceWithout = parseFloat(oldPriceWithoutText.replace('£', ''));

      
if (!isNaN(totalPrice) && !isNaN(oldPriceWithout)) {
    // Calcular la diferencia y mostrar el resultado en #saved-amount-number
    var savedAmount = totalPrice - oldPriceWithout;
    if (savedAmount >= 0) {
        $('#saved-amount-number').text('£' + savedAmount.toFixed(2));
        $('#saved-amount-number').show();
      
    } else {
        $('#saved-amount-number').hide();
    }

    var oldPriceWithout2 = parseFloat($('#old-price-without-2').text().trim().replace('£', ''));
    var savedAmountNumber2 = $('#saved-amount-number-2');
    var resultPrice2 = $('#result-price-2');
    if (!isNaN(oldPriceWithout2)) {
        var savedAmount2 = totalPrice - oldPriceWithout2;
        if (savedAmount2 >= 0) {
            savedAmountNumber2.text('£' + savedAmount2.toFixed(2));
            savedAmountNumber2.show();
          
        } else {
            savedAmountNumber2.hide();
        }
        resultPrice2.text('£' + totalPrice.toFixed(2));
    } else {
        console.error('Error: El valor de old-price-without-2 no es un número válido.');
    }
    var savedAmountElements = document.querySelectorAll('.saved-amount');
    savedAmountElements.forEach(function(element) {
        if (savedAmount >= 0) {
            element.style.display = 'block';
        }else{
            element.style.display = 'none';
        }
    });
    var retailAmountElements = document.querySelectorAll('.new-retail-price');
    retailAmountElements.forEach(function(element) {
        if (savedAmount >= 0) {
            element.style.display = 'block';
        }else{
            element.style.display = 'none';
        }
    });
} else {
    console.error(error,'Error: Los valores no son números válidos.');
}

    }
});

